export const FIREBASE_EVENTS = {
  projectsPage: {
    onOpenClick: `Click "Open"`,
    onLoadProjectClick: `Click "Load dataset"`,
    onExistingProjectClick: `Click "Open Existing Dataset"`,
  },
  variablesPage: {
    onExportToBrandAnalysisClick: `Click "Export to Brand Analysis"`,
    onExportToForstaClick: `Click "Export to Brand Analysis"`,
    onExportToPowerBIClick: `Click "Export to PowerBI click"`,
    onDownloadCsvClick: `Click "Download Original CSV"`,
    onDownloadModifiedCsvClick: `Click "Download Modified CSV"`,
    onDownloadSpssClick: `Click "Download Original SPSS"`,
    onDownloadModifiedSpssClick: `Click "Download Modified SPSS"`,
    onNewVariableClick: `Click "New Variable"`,
  },
  heatmapMainUi: {
    selectSourceImage: "Select Source Image",
    selectHeatmapQuestions: "Select Heatmap questions",
    selectFilterQuestions: "Select Filter Questions",
    whatClicksToInclude: "What clicks to include?",
    clickRadius: "Click Radius",
    transparencySlider: "Transparency Slider",
    enableClustering: "Enable Clustering",
    enableExpanded: "Enable Expanded",
    enableWeighting: "Enable Weighting",
    clusteringRadius: "Clustering Radius",
    export: "Export",
    openHeatmap: "Open Heatmap",
    downloadClicks: 'Click "Download Clicks"',
  },
};
